import React, { useState, useRef, useEffect, useMemo, useCallback } from "react";
import Button from '@mui/material/Button';
import 'ag-grid-enterprise';
import AgGridTable from "../utilities/AgGridTable";
import ListPageHeader from "../utilities/ListPageHeader";
import { useNavigate } from "react-router-dom";
import OAuthService from "src/app/auth/services/oAuthService";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import Select from 'react-select';
import { Box, Stack, Switch } from "@mui/material";
import DialogBox from "../utilities/DialogBox";
import 'ag-grid-community/styles/ag-theme-alpine.css';
import newProduct from 'src/assets/new-product.png';
import customStyles from 'app/shared-components/SelectCustomStyle';
import { forwardRef } from "react";
import moment from "moment";
import { useImperativeHandle } from "react";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import CustomDatePicker from "../utilities/CustomDatePicker";
import DoneIcon from '@mui/icons-material/Done';
    import { useMediaQuery, useTheme } from '@mui/material';

const DateEditorComponent = forwardRef((props, ref) => {
    const refDatePicker = useRef();
    const [error, setError] = useState("")
    const [validUntil, setValidUntil] = useState(null);

    const handleValidUntilChange = (newValue) => {
        setValidUntil(moment(newValue).format('YYYY-MM-DD'));
    };

    // useEffect(() => {
    //     if(props.data.validUntil){
    //         setValidUntil(props.data.validUntil);
    //     }
    // }, [props.data]);

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                if (validUntil !== null) {
                    return moment(validUntil).format('YYYY-MM-DD');
                }
            }
        };
    });

    const getProduct = async () => {
        const productUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.products}`;
        try {
            if (props.data.id) {
                const result = await OAuthService.getEditData(productUrl, props.data.id);
                const product = result?.data;
                setValidUntil(product?.validUntil);
            } else {
                setValidUntil(props.data.validUntil === undefined ? null : props.value);
            }
        } catch {
            console.log('error', error);
            setError(error.message);
        }
    }
    useEffect(() => {
        getProduct();
    }, [])

    return (
        <CustomDatePicker
            format={'dd-MM-yyyy'}
            name={"validUntil"}
            value={validUntil}
            handleChange={handleValidUntilChange}
            ref={refDatePicker}
        />
    );

});

const SelectEditorComponent = forwardRef((props, ref) => {
    const refVendor = useRef();
    const [error, setError] = useState("")
    const [vendors, setVendors] = useState([]);
    const [vendorShortKey, setVendorShortKey] = useState("");
    const getVendorsList = async () => {
        const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.factoryVendor}`;
        try {
            const list = await OAuthService.getList(url + `?size=1000`);
            let factoryVendorData = list.data?._embedded?.factoryVendors;
            factoryVendorData = factoryVendorData.map((vendor) => {
                const name = vendor.name;
                const shortKey = vendor.shortKey;
                const merge = `${name} ${shortKey}`
                return {
                    label: merge,
                    value: vendor.shortKey,
                    link: vendor._links?.self?.href
                }
            })
            setVendors(factoryVendorData);
        } catch (error) {
            setError(error.message);
        }
    }
    useEffect(() => {
        getVendorsList();
        // getProduct();
    }, []);

    const handleVendorChange = (value) => {
        if (value) {
            const vendorShortKey = value.map((row) => row.value);
            setVendorShortKey(vendorShortKey);
        }
    };

    useEffect(() => {
        const vendorShortKey = props?.value;
        if (vendorShortKey) {
            setVendorShortKey(vendorShortKey);
        }
      }, [props.data]);

    // const getProduct = async () => {
    //     const productUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.products}`;
    //     try {
    //         if (props.data.id) {
    //             const result = await OAuthService.getEditData(productUrl, props.data.id);
    //             const product = result?.data;
    //             const vendorsUrl = product._links?.vendor?.href;
    //             const getVendor = await OAuthService.getList(vendorsUrl);
    //             const vendors = getVendor.data._embedded.factoryVendors;
    //             const vendorShortKey = vendors.map((vendor) => vendor.shortKey);
    //             setVendorShortKey(vendorShortKey);
    //         } else {
    //             setVendorShortKey(props.data.vendor)
    //         }
    //     } catch {
    //         console.log('error', error);
    //         setError(error.message);
    //     }
    // }

    useImperativeHandle(ref, () => {
        return {
            getValue() {
                return vendorShortKey;
            }
        };
    });

    return (
        <div className="w-full" style={{ width: 250 }}>
            <Select
                className="basic-multi-select mb-4"
                name="name"
                required
                ref={refVendor}
                value={vendors.filter(obj => vendorShortKey?.includes(obj.value))}
                onChange={handleVendorChange}
                isMulti
                options={vendors}
                styles={customStyles()}
            />
        </div>
    );
});


const MaterialMaster = () => {
    
        const theme = useTheme();
         const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const productUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.products}`;
    const carcassUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.carcasses}`;
    const handleUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.handles}`;

    const [selectedRows, setSelectedRows] = useState([]);
    const [rowData, setRowData] = useState();
    const [filterData, setFilterData] = useState();
    const [productType, setProductType] = useState(sessionStorage.getItem('prType') ?? 'Range');
    const [gridApi, setGridApi] = useState(null);
    const perPage = 10;
    const [error, setError] = useState("");
    const gridRef = useRef();
    const [snackState, setSnackState] = useState(false);
    const [successMsg, setSuccessMsg] = useState();
    const [open, setOpen] = useState(false);
    const navigate = useNavigate();
    const [deleteDisable, setDeleteDisable] = useState(true);
    const [vendors, setVendors] = useState([]);
    const [edit, setEdit] = useState(false);
    const [updateData, setUpdateData] = useState();
    const [addRowData, setAddRowData] = useState([]);
    const [columnDefs, setColumnDefs] = useState([
      {
        field: "productId",
        enableRowGroup: true,
        headerName: "ID",
        editable: false,
        minWidth: 90,
      },
      {
        field: "_class",
        enableRowGroup: true,
        headerName: "Product Type",
        editable: false,
        minWidth: 140,
      },
      {
        field: "productName",
        enableRowGroup: true,
        cellRenderer: showNewIcon,
        type: "editableColumn",
        minWidth: 220,
      },
      {
        field: "productId",
        enableRowGroup: true,
        hide: true,
        type: "editableColumn",
        minWidth: 90,
      },
      {
        field: "validUntil",
        enableRowGroup: true,
        cellEditor: DateEditorComponent,
        type: "editableColumn",
        minWidth: 130,
      },
      {
        field: "active",
        cellRenderer: ActiveSwitch,
        editable: false,
        minWidth: 90,
      },
    ]);

    const columnTypes = useMemo(() => {
      return {
        editableColumn: {
          editable: (params) => {
            return (
              params.data._class === "Carcass" ||
              params.data._class === "Handle"
            );
          },
        },
      };
    }, []);

    async function getProductTypeValues(params) {
        const findAllProductUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findAllProduct}`;
        const data = { materialStatus: "true" }
        const list = await OAuthService.addData(findAllProductUrl, data);
        let productList = list.data;
        productList = productList.map((product) => {
            const vendorShortKey = product.vendor.map((vendors) => vendors.shortKey);
            const productName = product.productName?.toUpperCase();
            product.vendor = vendorShortKey.join(",");
            product.productName = product.isNew === true ? `${productName} (new)` : productName;
            if(product?._class === "Front Options"){
                product.priceGroup=product.range[0]?.priceGroup || null
            }
            return product;
        });
        setFilterData(productList)
    };

    const handleSwitchClick = () => {
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
    }

    const isRowSelectable = useMemo(() => {
        return (rowNode) => {
            return rowNode.data ? true : false;
        };
    }, []);
  function ActiveLacquered(props) {
    const isLacquered = props?.data?.lacquered;

    return (
      <div className="flex items-center justify-center">
        {isLacquered && <DoneIcon />}
      </div>
    );
  }

  function ActiveSwitch(props) {
    let bool = props?.data?.active;
    return (
      bool !== undefined && (
        <Switch
          size="small"
          checked={bool}
          onClick={() => {
            handleSwitchClick();
          }}
          color="success"
        />
      )
    );
  }
  function showNewIcon(props) {
    let name = props?.data?.productName;
    return (
      name && (
        <div
          className="flex items-center"
          style={{ position: "relative", width: "100%" }}
        >
          <div style={{ paddingRight: props?.data?.isNew ? 20 : 0 }}>
            {name}
          </div>
          {props?.data?.isNew === true && (
            <img
              src={newProduct}
              width="30"
              height="30"
              style={{ position: "absolute", right: 0, top: "-6px" }}
            />
          )}
        </div>
      )
    );
  }

    // const findMaterialMasterProduct = async () => {
    //     const data = { materialStatus: "true" }
    //     try {
    //         const findAllRangeUrl = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.findRanges}`;
    //         const rangeList = await OAuthService.getList(findAllRangeUrl);

    //         let productList = rangeList.data;
    //         productList = productList.map((product) => {
    //             const vendorShortKey = product.vendor.map((vendors) => vendors.shortKey);
    //             const productName = product.productName?.toUpperCase();
    //             product.vendor = vendorShortKey.join(",");
    //             product.productName = product.new === true ? `${productName} (new)` : productName;
    //             return product;
    //         })
    //         setRowData(productList);
    //     } catch (error) {
    //         setError(error.message);
    //         console.log(error);
    //     }
    // }

    const getVendorsList = async () => {
        const url = `${process.env.REACT_APP_RESOURCE_API_KEY_URL}${oAuthServiceConfig.factoryVendor}`;
        try {
            const list = await OAuthService.getList(url + `?size=1000`);
            let factoryVendorData = list.data?._embedded?.factoryVendors;
            setVendors(factoryVendorData);
        } catch (error) {
            setError(error.message);
        }
    }

    useEffect(() => {
        getVendorsList();
    }, [edit])

    useEffect(() => {
        getProductTypeValues();
    }, [])

    const changeActiveStatus = async(e) => {
        await Promise.all(selectedRows.map(async (row) => {
            try {
                const model = { active: !row.active }
              const {data} = await OAuthService.updateData(productUrl, row.id, model);
              if (data && data?.id) {
                const rowIndex = rowData?.findIndex(row => row.id === data.id);
                if (rowIndex !== -1) {
                  rowData[rowIndex].active = !row.active;
                  setRowData(rowData);
                }
                refreshCache();
              }
            } catch (error) {
                console.log(error)
            }
        }))
       
        setOpen(false);
    }

    const handlePurge = (e) => {
        selectedRows.map(async (row) => {
            try {
                const res = await OAuthService.deleteData(productUrl, row.id);
                let rowIndex = rowData.findIndex((data) => data.id === row.id);
                rowData.splice(rowIndex, 1);

                let dataIndex = filterData.findIndex((item) => item.id === row.id);
                filterData.splice(dataIndex, 1);
                if (res.status === 200) {
                    const selectedRow = gridApi.api.getSelectedRows();
                    gridRef?.current?.api.applyTransaction({ remove: selectedRow });
                    setSuccessMsg("Data deleted Successfully")
                    setSnackState(true);
                }
            } catch (error) {
                console.log("eror", error);
                setError(error.message);
            }
        })
    };

    const isRowMaster = useMemo(() => {
        return (dataItem) => {
            if (dataItem?.variations || dataItem?.products) {
                return dataItem ? dataItem?.variations?.length > 0 || dataItem?.products?.length > 0 ? true : false : false;
            }
        };
    }, []);

    const detailCellRendererParams = useMemo(() => {
        return {
          detailGridOptions: {
            rowSelection: "multiple",
            enableRangeSelection: true,
            pagination: true,
            paginationPageSize: 10,
            columnDefs: [
              {
                field: "productName",
                filter: "agMultiColumnFilter",
                minWidth: 200,
              },
              {
                field: "productId",
                filter: "agMultiColumnFilter",
                minWidth: 100,
              },
              {
                field: "productDescription",
                filter: "agMultiColumnFilter",
                minWidth: 200,
              },
              {
                field: "validUntil",
                filter: "agMultiColumnFilter",
                minWidth: 130,
              },
            ],
            defaultColDef: {
              floatingFilter: true,
              minWidth: 100,
              flex: 1,
              cellStyle: { borderRight: "1px solid #757575" },
            },
          },
          getDetailRowData: (params) => {
            params.successCallback(
              params.data.variations
                ? params.data.variations
                : params.data.products,
            );
          },
        };
    }, []);

    const onGridReady = useCallback((params) => {
        setGridApi(params);

        // findMaterialMasterProduct();
        var columnToolPanel = gridRef.current.api.getToolPanelInstance('columns');
        columnToolPanel.expandColumnGroups();
    }, [rowData]);

    const onBtExport = useCallback(() => {
      const params = {
        fileName: "MaterialMaster.xlsx",
        sheetName: "Material Master",
        processCellCallback: (params) => {
          if (params.column.getColId() === "range") {
            const value = params.value;

            if (Array.isArray(value)) {
              return value.map((r) => r.productName).join(", ");
            }
            return value || "";
          }

          return params.value;
        },
      };
      gridRef.current.api.exportDataAsExcel(params);
    }, []);

    const refreshCache = useCallback(() => {
        gridRef.current.api.redrawRows();
    }, []);

    const onSelectionChanged = (params) => {
        setSelectedRows(params.api.getSelectedRows());
    }

   
 const goToRoleEdit = useCallback(
      (data) => {
        if (data?.id !== undefined) {
          navigate("/editMaterialMaster-product/" + data.id);
        }
      },
      [navigate],
    );
    const onRowDoubleClicked = (params) => {
      if (isMobile) return;
      goToRoleEdit(params?.data);
    };

    const onRowClicked = (params) => {
      if (!isMobile) return;
      goToRoleEdit(params?.data);
    };
    useEffect(() => {
        if (selectedRows.length > 0) {
            setDeleteDisable(false)
        } else {
            setDeleteDisable(true)
        }
    }, [selectedRows]);

    const onColumnRowGroupChanged = useCallback(async (event) => {
        if (event.columns.length <= 0) {
            gridRef.current.columnApi.setColumnVisible("productId", true)
            gridRef.current.columnApi.setColumnVisible("_class", true)
        if (productType === "ProductBundle") {
        gridRef.current.columnApi.setColumnVisible("vendor", false);
      } else {
        gridRef.current.columnApi.setColumnVisible("vendor", true);
      }
      if (productType === "Range") {
        gridRef.current.columnApi.setColumnVisible("priceGroup", true);
      } else {
        gridRef.current.columnApi.setColumnVisible("priceGroup", false);
      }
      if (productType === "Front Options") {
        gridRef.current.api.stopEditing();
      }
        } else {
            gridRef.current.columnApi.setColumnVisible("productId", false);
            gridRef.current.columnApi.setColumnVisible("_class", false);
        }
    }, [])

    const onRowValueChanged = useCallback(async (event) => {
        let data = event.data;
        const vendorLink = vendors.filter((ven) => data.vendor.includes(ven.shortKey)).map((item) => item._links.self.href);
        const model = {
            id: data.id,
            productId: data.productId,
            productName: data.productName,
            vendor: vendorLink,
            validUntil: data.validUntil,
            active: data.active,
            _class: data._class,
            isNew: data.isNew,
        }
        setUpdateData(model);
    }, [vendors]);

    const onBtAdd = useCallback((event) => {
        setEdit(true);
        const newRow = {
            active: true,
            isNew: true,
            _class: event.node.data._class
        }
        const RowIndex = event.node.rowIndex + 1;
        let index = rowData.findIndex((row) => row.id === event.node.data.id);
        const nextIndex = index + 1;
        rowData.splice(nextIndex, 0, newRow);
        filterData.splice(nextIndex, 0, newRow);
        gridRef.current.api.applyTransaction({ add: [newRow], addIndex: nextIndex });
        gridRef.current.api.refreshCells();
        const data = [...addRowData, newRow]
        setAddRowData(data);
        setTimeout(() => {
            gridRef.current.api.setFocusedCell(RowIndex, 'active')
            gridRef.current.api.startEditingCell({
                rowIndex: RowIndex,
                colKey: 'active',
            });
        }, 800);
    }, [addRowData, rowData, filterData]);

    const onBtStartEditing = useCallback((event) => {
        setEdit(true);
        const data = event.node.data;
        const index = event.node.rowIndex;
        gridRef.current.api.setFocusedCell(index, 'active')
        gridRef.current.api.startEditingCell({
            rowIndex: index,
            colKey: 'active',
        });
    }, [edit, rowData]);

    const onBtCopyRow = useCallback((event) => {
        setEdit(true);
        const copyRow = {
            productId: event.node.data.productId,
            productName: event.node.data.productName,
            vendor: event.node.data.vendor,
            validUntil: event.node.data.validUntil,
            active: true,
            _class: event.node.data._class,
            isNew: true,
        };
        const RowIndex = event.node.rowIndex + 1;
        let index = rowData.findIndex((row) => row.id === event.node.data.id);
        const nextIndex = index + 1;
        rowData.splice(nextIndex, 0, copyRow);
        filterData.splice(nextIndex, 0, copyRow);
        gridRef.current.api.applyTransaction({ add: [copyRow], addIndex: nextIndex });
        gridRef.current.api.refreshCells();
        const data = [...addRowData, copyRow]
        setAddRowData(data);
        setTimeout(() => {
            gridRef.current.api.setFocusedCell(RowIndex, 'active')
            gridRef.current.api.startEditingCell({
                rowIndex: RowIndex,
                colKey: 'active',
            });
        }, 800);
    }, [addRowData, rowData, filterData]);

    const onBtDeleteRow = useCallback((event) => {
        const selectedRow = gridApi.api.getSelectedRows();
        rowData.splice(event.node.rowIndex, 1);
        filterData.splice(event.node.rowIndex, 1);
        gridRef?.current?.api.applyTransaction({ remove: selectedRow });
        selectedRow.map(async (row) => {
            await OAuthService.deleteData(productUrl, row.id);
        })
    }, [gridRef, gridApi, rowData, filterData]);

    const getContextMenuItems = (event) => {
        if (event.node.data._class === "Carcass" || event.node.data._class === "Handle") {
            var result = [
                {
                    name: "Add Row",
                    icon: '<span><i class="material-icons style="font-size: 18px">perm_identity</i></span>',
                    action: () => {
                        onBtAdd(event);
                    },
                },
                {
                    name: "Edit Row",
                    icon: '<span><i class="material-icons" style="font-size: 18px">edit</i></span>',
                    action: () => {
                        onBtStartEditing(event);
                    },
                },
                {
                    name: "View Row",
                    icon: '<span><i class="material-icons" style="font-size: 18px">copy</i></span>',
                    action: () => {
                        onBtCopyRow(event);
                    },
                },
                {
                    name: "Delete Row",
                    icon: '<span><i class="material-icons" style="font-size: 18px">delete</i></span>',
                    action: () => {
                        onBtDeleteRow(event);
                    },
                },
            ];
            return result;
        }
    };

    const SaveRowBtn = () => {
        const productData = [
            { value: "Range", label: "Range" },
            { value: "Front Options", label: "Front Options" },
            { value: "Carcass", label: "Carcass" },
            { value: "Handle", label: "Handle" },
            { value: "POSMaterial", label: "POS Material" },
            { value: "Generic", label: "Generic" },
            { value: "ProductBundle", label: "Bundled Product" },
        ]

        const handleProductChange = (data,action) => {
            setProductType(action.action === "clear"?"":data.value);
            sessionStorage.setItem("prType", data?.value || '');
            // if (data.value === "ProductBundle") {
            //     gridRef.current.columnApi.setColumnVisible("vendor", false)
            // } else {
            //     gridRef.current.columnApi.setColumnVisible("vendor", true)
            // }
            // if (data.value === "Range") {
            //     gridRef.current.columnApi.setColumnVisible("priceGroup", true)
            // } else {
            //     gridRef.current.columnApi.setColumnVisible("priceGroup", false)
            // }
            // if(data.value === "Front Options"){
            //     gridRef.current.columnApi.setColumnVisible("priceGroup", true)
            //     // gridRef.current?.columnApi?.setColumnVisible("range", true)
            //     gridRef.current.api.stopEditing();
            // } else {
            //     // gridRef.current?.columnApi?.setColumnVisible("range", false)
            // }
        };
        useEffect(() => {
            if (productType) {
                const filterProducts = filterData?.filter((item) => productType === item._class);
                setRowData(filterProducts)
            }else{
                setRowData(filterData)
            }
        }, [productType, filterData])

        const handleSubmit = async () => {
            if (updateData?.id) {
                const responce = await OAuthService.updateData(productUrl, updateData.id, updateData);
                if (responce.status === 200) {
                    setEdit(false);
                    setSuccessMsg("Row Updated Successfully")
                    setSnackState(true);
                    setUpdateData("");
                    setTimeout(() => { setSnackState(false) }, 2000);
                }
            } else {
                await Promise.all(addRowData.map(async (row) => {
                    if (row.productId && row.validUntil && row.vendor.length !== 0 && row.productName) {
                        const vendorLink = vendors.filter((ven) => row.vendor?.includes(ven.shortKey)).map((item) => item._links.self.href);
                        row.vendor = vendorLink;
                        if (row._class === "Carcass") {
                            const responce = await OAuthService.addData(carcassUrl, row);
                            if (responce.status === 201) {
                                setEdit(false);
                                // findMaterialMasterProduct();
                                getProductTypeValues();
                                // getFilterValue();
                                setSuccessMsg("Row added Successfully")
                                setSnackState(true);
                                setTimeout(() => { setSnackState(false) }, 1000);
                            }
                        } else {
                            const responce = await OAuthService.addData(handleUrl, row);
                            if (responce.status === 201) {
                                setEdit(false);
                                // findMaterialMasterProduct();
                                getProductTypeValues();
                                setSuccessMsg("Row added Successfully")
                                setSnackState(true);
                                setTimeout(() => { setSnackState(false) }, 1000);
                            }
                        }
                    } else {
                        setSuccessMsg("Please fill in the blank")
                        setSnackState(true);
                        setTimeout(() => { setSnackState(false) }, 3000);
                    }
                }))
            }
        }

        const selectStyles = {
    ...customStyles(),
    menuPortal: (styles) => ({ ...styles, zIndex: 9999 }),
    menu: (styles) => ({ ...styles, zIndex: 9999 }),
    option: (styles, state) => ({
      ...styles,
      whiteSpace: "normal",
      wordBreak: "break-word",
    }),
  };

  return (
    <>
      <Box sx={{ width: { xs: "100%", sm: 190 } }}>
        <Select
          className="mb-16"
          name="product"
          placeholder="Select Product"
          value={(productType && productData) && productData.filter((obj) => productType === obj.value)}
          onChange={handleProductChange}
          options={productData}
          styles={selectStyles}
          menuPortalTarget={document.body}
          isClearable
        />
      </Box>
      {edit && (
        <Button
          variant="contained"
          color="warning"
          onClick={handleSubmit}
          style={{ marginBottom: "5px", fontWeight: "bold" }}
        >
          <FuseSvgIcon>heroicons-solid:document</FuseSvgIcon>
        </Button>
      )}
    </>
  );
    }
    useEffect(() => {
      const rangeData = {
        field: "range",
        headerName: "Range",
        enableRowGroup: true,
        type: "editableColumn",
        editable: false,
        valueFormatter: (params) => {
          const value = params?.value;

          if (Array.isArray(value)) {
            return value.map((range) => range.productName).join(", ");
          }

          return value ?? "";
        },
        filter: "agMultiColumnFilter",
        filterValueGetter: (params) =>
          params?.data?.range
            ? params.data.range.map((r) => r.productName).join(", ")
            : "",
      };
      const priceGroupData = {
        field: "priceGroup",
        enableRowGroup: true,
        headerName: "Price Group",
        minWidth: 70,
        cellRenderer: (props) => {
          return props?.data?.priceGroup?.pgId;
        },
        type: "editableColumn",
        valueGetter: (params) => {
          const value = params.data?.priceGroup?.pgId;
          return value;
        },

        filter: "agMultiColumnFilter",
      };
      const vendorData = {
        field: "vendor",
        minWidth: 70,
        enableRowGroup: true,
        type: "editableColumn",
        cellEditorPopup: true,
        cellEditor: SelectEditorComponent,
      };
      const lacqueredFlag = {
        field: "lacquered",
        headerName: "Lacquered",
        enableRowGroup: true,
        minWidth: 70,
        cellRenderer: ActiveLacquered,
      };
      if (productType === "Front Options") {
        const clone = [...columnDefs];
        if (clone.filter((item) => item.field === "range").length === 0) {
          clone.push({ ...rangeData });
        }

        if (clone.filter((item) => item.field === "priceGroup").length === 0) {
          clone.push({ ...priceGroupData });
        }
        if (clone.filter((item) => item.field === "vendor").length === 0) {
          clone.push({ ...vendorData });
        }
        const lacqueredIndex = clone.findIndex(
          (item) => item.field === "lacquered"
        );
        if (lacqueredIndex !== -1) {
          clone.splice(lacqueredIndex, 1);
        }
        setColumnDefs(clone);
      } else if (productType === "Range") {
        const clone = [...columnDefs];
        if (clone.filter((item) => item.field === "priceGroup").length === 0) {
          clone.push({ ...priceGroupData });
        }
        if (clone.filter((item) => item.field === "vendor").length === 0) {
          clone.push({ ...vendorData });
        }
        if (clone.filter((item) => item.field === "lacquered").length === 0) {
          clone.push({ ...lacqueredFlag });
        }
        if (clone.filter((item) => item.field === "range").length) {
          const findIndex = clone.findIndex((item) => item.field === "range");
          if (findIndex !== -1) {
            clone.splice(findIndex, 1);
          }
        }
        setColumnDefs(clone);
      } else if (
        productType === "Carcass" ||
        productType === "Handle" ||
        productType === "POSMaterial" ||
        productType === "Generic"
      ) {
        const clone = [...columnDefs];
        if (clone.filter((item) => item.field === "vendor").length === 0) {
          clone.push({ ...vendorData });
        }
        if (clone.filter((item) => item.field === "range").length) {
          const findIndex = clone.findIndex((item) => item.field === "range");
          if (findIndex !== -1) {
            clone.splice(findIndex, 1);
          }
        }
        const lacqueredIndex = clone.findIndex(
          (item) => item.field === "lacquered"
        );
        if (lacqueredIndex !== -1) {
          clone.splice(lacqueredIndex, 1);
        }
        if (clone.filter((item) => item.field === "priceGroup").length) {
          const findIndex = clone.findIndex(
            (item) => item.field === "priceGroup"
          );
          if (findIndex !== -1) {
            clone.splice(findIndex, 1);
          }
        }
        setColumnDefs(clone);
      } else {
        const clone = [...columnDefs];
        if (clone.filter((item) => item.field === "range").length) {
          const findIndex = clone.findIndex((item) => item.field === "range");
          if (findIndex === -1) {
            clone.push({ ...rangeData });
          }
        }
        if (clone.filter((item) => item.field === "priceGroup").length) {
          const findIndex = clone.findIndex(
            (item) => item.field === "priceGroup"
          );
          if (findIndex === -1) {
            clone.push({ ...priceGroupData });
          }
        }
        if (clone.filter((item) => item.field === "vendor").length) {
          const findIndex = clone.findIndex((item) => item.field === "vendor");
          if (findIndex === -1) {
            clone.push({ ...vendorData });
          }
        }
        const lacqueredIndex = clone.findIndex(
          (item) => item.field === "lacquered"
        );
        if (lacqueredIndex !== -1) {
          clone.splice(lacqueredIndex, 1);
        }
        setColumnDefs(clone);
      }
    }, [productType]);

    const onResetColumnState = ()=>{
        if (productType === "ProductBundle") {
            gridRef.current?.columnApi?.setColumnVisible("vendor", false)
            gridRef.current?.columnApi?.setColumnVisible("priceGroup", false)
        } else {
            gridRef.current?.columnApi?.setColumnVisible("vendor", true)
        }
        if (productType === "Range") {
            gridRef.current?.columnApi?.setColumnVisible("priceGroup", true)
        } else {
            gridRef.current?.columnApi?.setColumnVisible("priceGroup", false)
        }
        if(productType === "Front Options"){
            gridRef.current?.columnApi?.setColumnVisible("priceGroup", true)
            gridRef.current?.columnApi?.setColumnVisible("range", true)
            gridRef.current?.api?.stopEditing();
        }else{
            gridRef.current?.columnApi?.setColumnVisible("range", false)
        }
        gridRef.current?.api?.refreshCells();
    }

    const groupSearchColumn = (params) => {
        return `${params.data.productId || ''}`.trim()
    }

    return (
      <>
        <ListPageHeader
          componentName="Material Master"
          headerInputFields={SaveRowBtn()}
          onBtExport={onBtExport}
          handlePurge={handlePurge}
          addPageLink="/addMaterialMaster-product"
          pageName="Material Master List"
          error={error}
          deleteDisable={deleteDisable}
          successMsg={successMsg}
          snackState={snackState}
          gridRef={gridRef}
          onResetColumnState={onResetColumnState}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flex: "1 1 auto",
            minHeight: 0,
            minWidth: 0,
            width: "100%",
          }}
        >
          <div
            style={{
              flex: "1 1 auto",
              minHeight: 400,
              minWidth: 0,
              width: "100%",
              height: isMobile ? "calc(100vh - 220px)" : "calc(100vh - 160px)",
              overflow: "hidden",
            }}
          >
            <AgGridTable
              rowData={rowData}
              columnDefs={columnDefs}
              onGridReady={onGridReady}
              onSelectionChanged={onSelectionChanged}
              onRowDoubleClicked={onRowDoubleClicked}
              onRowClicked={onRowClicked}
              gridRef={gridRef}
              groupSearchColumn={groupSearchColumn}
              paginationPageSize={perPage}
              detailCellRendererParams={detailCellRendererParams}
              masterDetail={true}
              isRowMaster={isRowMaster}
              isRowSelectable={isRowSelectable}
              autoGroupField={"productId"}
              tableClassName={"header-cell-line"}
              cacheBlockSize={perPage}
              getContextMenuItems={getContextMenuItems}
              editable={true}
              editType={"fullRow"}
              columnTypes={columnTypes}
              onRowValueChanged={onRowValueChanged}
              onColumnRowGroupChanged={onColumnRowGroupChanged}
              saveGridStateName={"materialMasterList"}
              filterValueGetter={"_class"}
            />
          </div>
        </div>

        <DialogBox
          open={open}
          handleClose={handleClose}
          handleSumbit={changeActiveStatus}
          title={"change active status"}
        />
      </>
    );
}

export default MaterialMaster